<template>
    <v-card class="pa-5 mb-3">
        <h3>Configurations</h3>
        <p>Define quarter start dates: </p>
        <div class="annual-summary-quarters">
            <AnnualSummaryConfigurationSeasonStartDateComponent v-for="quarter in quarters" :key="`quarter_${quarter.id}`" :quarter="quarter"/>
        </div>
        <div class="d-flex mt-3 annual-summary-block-table-footer justify-end">
            <v-btn @click="handleAddQuarterClick">+</v-btn>
        </div>
    </v-card>
</template>

<script>
import AnnualSummaryConfigurationSeasonStartDateComponent
    from './AnnualSummaryConfigurationSeasonStartDateComponent.vue';
import { mapMutations, mapState } from 'vuex';

export default {
    name: 'AnnualSummaryConfigurationComponent',
    components: {AnnualSummaryConfigurationSeasonStartDateComponent},
    computed: {
        ...mapState('quarter', ['quarters'])
    },
    methods: {
        ...mapMutations('quarter', ['addQuarter']),
        handleAddQuarterClick() {
            this.addQuarter()
        }
    }
};
</script>

<style scoped lang="scss">
</style>